export default function ForceFooter() {
  return (
    <footer className="bg-force-bg w-full mt-auto border-t border-force-border-light">
      <div className="flex flex-col md:flex-row justify-between items-center py-stack-lg px-margin-mobile md:px-margin-desktop max-w-container-max mx-auto w-full gap-4">
        <div className="font-title-md text-title-md font-bold text-force-text flex items-center gap-2">
          FORCE <span className="text-force-green-light">AI</span>
        </div>
        <nav className="flex flex-wrap justify-center gap-6">
          <a className="font-body-md text-body-md text-force-text-muted hover:text-force-text transition-colors" href="#">
            Privacy Policy
          </a>
          <a className="font-body-md text-body-md text-force-text-muted hover:text-force-text transition-colors" href="#">
            Terms of Service
          </a>
          <a className="font-body-md text-body-md text-force-text-muted hover:text-force-text transition-colors" href="#">
            Support Center
          </a>
        </nav>
        <div className="font-caption text-caption text-force-text-muted text-center md:text-right">
          AI-simulated psychology tests for the Services Selection Board.
        </div>
      </div>
    </footer>
  )
}
